export default "/images/my-giving.svg?6d3315ddd0aaff24c0a6e1e45fa66032";